export default __webpack_public_path__ + "media/meditationMockup.ede6a02c.mp4";